module.exports = {
    tableHeading: ['ID', 'NAME', 'INVOICE(€)']
}
